import React, { useEffect, useState, SetStateAction } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import service from "../../../../api/services";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import {
    getDropdown,
    getParams,
    getUniqueObj,
} from "../../../../constants/utils";
import constant from "../../../../constants/constant";
import {
    AddInvoiceData,
    SearchProduct,
    TProductType,
    TStoreDropDown,
    ProductData,
    TSearchProduct,
    THandleCalculation,
    InvoicePayload,
    TSupplierDropDown,
} from "./interface";
import { useCalculation } from "./hook/useCalculation";
import { useDropDown } from "./hook/useDropDown";
import { usePreparePayload } from "./hook/usePreparePayload";
import { useEditData } from "./hook/useEditData";
const { AddInventoryOrganism } = organisms;
const AddInventory = () => {
    const navigate = useNavigate();
    const { getStoreDropdown,getSupplierDropdown } = useDropDown();
    const {  handleSearchSelect,handleCalculation } = useCalculation();
    const { addInvoicePayload } = usePreparePayload()
    const {handleEditData} = useEditData()
    const { addToast } = useToasts();
    let params = useParams();
    const [typeValue, setTypeValue] = useState<any>(getParams("isRecognized"));
    let invoiceEditID = params.id || "";
    const [search, setSearch] = useState<string>("");
    const [productData, setProductData] = useState<ProductData[]>([]);
    const [allProductList, setAllProductList] = useState([]);
    const [previewTab, setPreviewTab] = useState(false);
    const [supplierData, setSupplierData] = useState<TSupplierDropDown[]>([]);
    const [storeData, setStoreData] = useState<TStoreDropDown[]>([]);
    const [buttonClick, setButtonClick] = useState(false);
    const [regionCode, setRegionCode] = useState<number>(
        constant.STORE_REGION.INDIA
    );

    const [invoiceData, setInvoiceData] = useState<AddInvoiceData>({
        store_id: null,
        invoice_id: "",
        invoice_count: "",
        supplier_id: null,
        supplier_invoice_number: "",
        supplier_invoice_date: "",
        category: null,
        actual_invoice: "",
        total_srp: "",
        remark: "",
        invoice_file: []
    });
    
    const getSupplierandStoreData = async () => {
        try {
            let SupplierAndStoreResponse =
                await service.inventory.supplierAndStoreData();
            setSupplierData(
                getSupplierDropdown( SupplierAndStoreResponse?.data?.data?.suppliers)
            );
            setStoreData(
                getStoreDropdown(SupplierAndStoreResponse?.data?.data?.stores)
            );
        } catch (error) {
            console.error(error);
        }
    };
    const getGSTByRegion = (value: TProductType | undefined): number => {
        if(!value) return 0
        let isKuwaitRegion: boolean = regionCode === constant.STORE_REGION.KUWAIT;
        return isKuwaitRegion ? value.tax_rate ?? 0 : value?.gst_percentage;
    };

    const getProductData = async (data: string) => {
        try {
            // let response = await service.product.view({ "search": e ,"id":id})
            let id = invoiceData?.store_id?.value;
            let response = await service.product.addInventorySearch({
                search: data,
                storeId: id,
                is_recognised: typeValue,
            });
            const updateProductKeys: SetStateAction<never[]> =
                response?.data?.data?.map((product: SearchProduct) => {
                    let qty = 1;
                    let tempGstAmount =
                        (product.product_srp *
                            getUniqueObj(
                                product.brand.product_types,
                                "product_type_id",
                                product.product_type_id
                            )?.specx_landing_cost) /
                        100;
                    let tempTotalCostAmount = tempGstAmount * qty;
                    let gst_amount =
                        (tempTotalCostAmount * getGSTByRegion(product?.product_type)) /
                        (100 + getGSTByRegion(product?.product_type));
                    let cost_amount: number | string | any = (
                        (product?.product_srp || 0) *
                        getUniqueObj(
                            product?.brand?.product_types,
                            "product_type_id",
                            product?.product_type_id
                        )?.specx_landing_cost *
                        0.01
                    ).toFixed(2);
                    let total_price = cost_amount * qty;
                    let srp_amount = product?.product_srp * qty;
                    return {
                        ...product,
                        cost_amount,
                        qty,
                        total_price,
                        gst_amount,
                        srp_amount,
                    };
                });

            setAllProductList(updateProductKeys);
        } catch (error) {
            console.error(error);
        }
    };


    const getCount = async () => {
        const payload = {
            category: Number(invoiceData?.category?.value),
            store_id: invoiceData?.store_id?.value || "",
        };

        try {
            let response: any = await service.inventory.getInvoiceDataCount(payload);
            if (response.status === 200) {
                setInvoiceData({ ...invoiceData, invoice_count: response.data.count });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getInvoiceDataById = async () => {
        try {
            let response = await service.inventory.getDetailById(invoiceEditID);
            handleEditData({response:response.data.data,
                setProductData,
                setInvoiceData,
                setRegionCode,});
        } catch (error) {
            console.error("error", error);
        }
    };

    const addInvoice = async () => {
        let payload:InvoicePayload =  addInvoicePayload({productData,invoiceData});
        try {
            let response: any;
            if (invoiceEditID) {
                response = await service.inventory.edit(invoiceEditID, payload);
            } else {
                response = await service.inventory.add(payload);
            }
            if (response.status === 201) {
                addToast(response?.data?.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                navigate(-1);
            } else if (response?.status === 200) {
                addToast(response?.data?.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                navigate(-1);
            }
        } catch (error: any) {
            addToast(error.response?.data?.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
        setButtonClick(false);
    };

    useEffect(() => {
        const hasStoreAndSupplierData =
            storeData?.length > 0 && supplierData?.length > 0;

        if (hasStoreAndSupplierData) {
            if (invoiceEditID) {
                getInvoiceDataById();
            }
        }
    }, [storeData, supplierData, invoiceEditID]);

    useEffect(() => {
        if (!params.id && invoiceData?.store_id && invoiceData?.category?.value) {
            getCount();
        }
    }, [invoiceData?.store_id, invoiceData?.category?.value]);

    useEffect(() => {
        if (buttonClick) {
            addInvoice();
        }
    }, [buttonClick]);

    useEffect(() => {
        getSupplierandStoreData();
    }, []);


    return (
        <Wrapper>
            <AddInventoryOrganism
                search={search}
                setSearch={setSearch}
                productData={productData}
                allProductList={allProductList}
                handleSearchSelect={(response: TSearchProduct) =>
                    handleSearchSelect({
                        response,
                        prevData: productData,
                        setProductData,
                        regionCode,
                        gstType:invoiceData?.supplier_id?.gst_type || constant?.GST_TYPE[0].value
                    })
                }
                setProductData={setProductData}
                previewTab={previewTab}
                setPreviewTab={setPreviewTab}
                setAllProductList={setAllProductList}
                supplierData={supplierData}
                storeData={storeData}
                invoiceData={invoiceData}
                setInvoiceData={setInvoiceData}
                setButtonClick={(e: any) => setButtonClick(e)}
                getProductData={(data: string) => getProductData(data)}
                typeValue={typeValue}
                setRegionCode={(value: number) => setRegionCode(value)}
                regionCode={regionCode}
                handleCalculation={({type,id,value}:THandleCalculation)=> handleCalculation({productData,
                    setProductData,
                    type,
                    id,
                    getGSTByRegion,
                    value,})}
            />
        </Wrapper>
    );
};
export default AddInventory;
